import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

const fmUrl = `${apiUrl}FileManagement`;

export const requestGetFolders = () =>
    axios.get(`${fmUrl}/folders`);

export const requestCreateFolder = (fullName, parentId) =>
    axios.post(`${fmUrl}/folders`, {
        fullName,
        parentId
    });

export const requestGetFolderInfoById = (folderId) =>
    axios.get(`${fmUrl}/folders/${folderId}`);

export const requestUpdateFolderById = (folderId, data) =>
    axios.put(`${fmUrl}/folders/${folderId}`, {
        folderId: data.folderId,
        fullName: data.fullName,
        parentId: data.parentId
    });

export const requestDeleteFolderById = (folderId) =>
    axios.delete(`${fmUrl}/folders/${folderId}`);

export const requestGetFilesByFolderId = (folderId) =>
    axios.get(`${fmUrl}/folders/${folderId}/files`);

export const requestCreateFilesByFolderId = (folderId, files) => {
    const formData = new FormData();
    files.map(file => formData.append("files", file));

    return axios.post(`${fmUrl}/folders/${folderId}/files`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    });
};

export const requestGetFileInfoById = (fileId) =>
    axios.get(`${fmUrl}/files/${fileId}`, {
        responseType: "blob"
    });

export const requestDownloadFilesByFileId = (fileId) =>
    axios.get(`${fmUrl}/files/${fileId}/download`, {
        responseType: "blob"
    });

export const requestUpdateFileByFileId = (fileId, data) =>
    axios.put(`${fmUrl}/files/${fileId}`, data);

export const requestDeleteFileByFileId = (fileId) =>
    axios.delete(`${fmUrl}/files/${fileId}`);


/* UME */
const UMEUrl = `${fmUrl}/UME`;

export const requestUmeGetFolders = () =>
    axios.get(`${UMEUrl}/folders`);

export const requestUmeCreateFolder = (fullName, parentId) =>
    axios.post(`${UMEUrl}/folders`, {
        fullName,
        parentId
    });

export const requestUmeGetFolderInfoById = (folderId) =>
    axios.get(`${UMEUrl}/folders/${folderId}`);

export const requestUmeUpdateFolderById = (folderId, data) =>
    axios.put(`${UMEUrl}/folders/${folderId}`, {
        folderId: data.folderId,
        fullName: data.fullName,
        parentId: data.parentId
    });

export const requestUmeDeleteFolderById = (folderId) =>
    axios.delete(`${UMEUrl}/folders/${folderId}`);

export const requestUmeGetFilesByFolderId = (folderId) =>
    axios.get(`${UMEUrl}/folders/${folderId}/files`);

export const requestUmeCreateFilesByFolderId = (folderId, files) => {
    const formData = new FormData();
    files.map(file => formData.append("files", file));

    return axios.post(`${UMEUrl}/folders/${folderId}/files`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    });
};

export const requestUmeGetFileInfoById = (fileId) =>
    axios.get(`${UMEUrl}/files/${fileId}`, {
        responseType: "blob"
    });

export const requestUmeDownloadFilesByFileId = (fileId) =>
    axios.get(`${UMEUrl}/files/${fileId}/download`, {
        responseType: "blob"
    });

export const requestUmeUpdateFileByFileId = (fileId, data) =>
    axios.put(`${UMEUrl}/files/${fileId}`, data);

export const requestUmeDeleteFileByFileId = (fileId) =>
    axios.delete(`${UMEUrl}/files/${fileId}`);

export const requestUmeGetFolderPermissions = (folderId) =>
    axios.get(`${UMEUrl}/folders/${folderId}/permissions`);

export const requestUmeCreateFolderPermissions = (folderId, data) =>
    axios.post(`${UMEUrl}/folders/${folderId}/permissions`, data);

export const requestUmeDeleteFolderPermissions = (folderId) =>
    axios.delete(`${UMEUrl}/folders/${folderId}/permissions`);

// export const requestUmeGetFolderPermissionsById = (permissionId) =>
//     axios.get(`${UMEUrl}/folders/permissions/${permissionId}`);

export const requestUmeDeleteFolderPermissionsById = (permissionId) =>
    axios.delete(`${UMEUrl}/folders/permissions/${permissionId}`);
